import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { EModRadius, IModRadius } from '@ucheba/utils/helpers/styles/mod.types'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import { IPropHeight, IPropWidth } from '@ucheba/utils/helpers/components/prop.types'

const PreviewOverlayImage = styled.img<StyledProps<IModRadius>>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  z-index: 3;
  ${Object.keys(EModRadius).map(
    (item) => sm.mod(EModRadius[item])`
        border-radius: ${sv.radius[item]};
      `
  )};
`

const PreviewOverlayWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
`

const Blackout = styled.div<StyledProps<IModRadius> & any>`
  background-color: ${(props) => (props.notHover ? 'transparent' : sv.color.gray40)};
  opacity: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity ${sv.duration.fast} linear;
  z-index: 1;
  ${Object.keys(EModRadius).map(
    (value) => sm.mod(EModRadius[value])`
        border-radius: ${sv.radius[value]};
      `
  )};
`

const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const PlayIconWrapper = styled.div`
  position: absolute;
  z-index: 4;
`

const Block = styled.div<StyledProps<IPropWidth & IPropHeight>>`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.height};
  width: ${(props) => props.width};

  &:hover ${Blackout} {
    opacity: 0;
  }
`

export default {
  Block,
  PreviewOverlayImage,
  PreviewOverlayWrapper,
  Blackout,
  PreviewImage,
  PlayIconWrapper,
}
